import React from 'react';
import { motion } from 'framer-motion';
import { FaGithub, FaLinkedin, FaUser } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

// Componente de imagen de perfil alternativa
const ProfilePlaceholder = ({ darkMode }) => (
    <div className={`w-full h-full flex items-center justify-center ${
        darkMode ? 'bg-gray-700 text-cyan-400' : 'bg-gray-100 text-cyan-600'
    }`}>
        <FaUser className="text-6xl" />
    </div>
);

const Hero = ({ darkMode }) => {
    const { t } = useTranslation();

    return (
        <section id="home" className="flex flex-col md:flex-row items-center justify-between py-16">
            <motion.div
                initial={{ opacity: 0, x: -50 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                className="md:w-1/2 mb-8 md:mb-0"
            >
                <h1 className={`text-4xl md:text-5xl font-bold mb-4 ${darkMode ? 'text-cyan-400' : 'text-cyan-600'}`}>
                    {t('hero.title')}
                </h1>
                <h2 className="text-2xl md:text-3xl font-semibold mb-4">
                    {t('hero.subtitle')}
                </h2>
                <p className="text-lg mb-6">
                    {t('hero.description')}
                </p>

                <div className="flex space-x-4">
                    <a
                        href="https://github.com/FriasLuna0102"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`text-2xl hover:scale-110 transition-transform ${darkMode ? 'text-gray-300 hover:text-white' : 'text-gray-700 hover:text-black'}`}
                    >
                        <FaGithub />
                    </a>
                    <a
                        href="https://www.linkedin.com/in/starlin-jose-frías-luna-03190628b/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`text-2xl hover:scale-110 transition-transform ${darkMode ? 'text-gray-300 hover:text-white' : 'text-gray-700 hover:text-black'}`}
                    >
                        <FaLinkedin />
                    </a>
                    <a
                        href="mailto:starlinluna0102@gmail.com"
                        className={`px-4 py-2 rounded-md font-medium hover:scale-105 transition-transform ${
                            darkMode
                                ? 'bg-cyan-600 hover:bg-cyan-500 text-white'
                                : 'bg-cyan-500 hover:bg-cyan-600 text-white'
                        }`}
                    >
                        {t('hero.contactMe')}
                    </a>
                </div>
            </motion.div>

            <motion.div
                initial={{ opacity: 0, x: 50 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                className="md:w-2/5"
            >
                <div className={`rounded-full w-64 h-64 mx-auto overflow-hidden border-4 ${
                    darkMode ? 'border-cyan-400 shadow-cyan-400/20' : 'border-cyan-600 shadow-cyan-600/20'
                } shadow-lg`}>
                    {/* Usamos un enfoque más robusto para la imagen de perfil */}
                    <div className="w-full h-full">
                        <img
                            src={`${process.env.PUBLIC_URL}/images/profile-image.jpg`}
                            alt="Starlin Frías"
                            className="w-full h-full object-cover"
                            onError={(e) => {
                                e.target.style.display = 'none';
                                // Revelar el div de respaldo que contiene nuestro placeholder personalizado
                                e.target.nextElementSibling.style.display = 'flex';
                            }}
                        />
                        {/* Este div solo se muestra cuando la imagen falla */}
                        <div style={{ display: 'none' }} className="w-full h-full">
                            <ProfilePlaceholder darkMode={darkMode} />
                        </div>
                    </div>
                </div>
            </motion.div>
        </section>
    );
};

export default Hero;